import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { getBidList, addBidToPendingList } from "../../Redux/Gem/Action";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import NewDataTable from "../DataTable/NewDataTable";
import { format } from "date-fns";
import { BsFillBookmarkStarFill } from "react-icons/bs";

const GemBid = () => {

    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const loginId = localStorage.getItem("loginId");
    const { gembidlist } = useSelector((store) => store.gem);

    useEffect(() => {
        dispatch(getBidList(token));
    }, [dispatch, token, loginId]);

    const Tooltip = ({ text, children }) => {
        return (
            <div className="tooltip-container">
                {children}
                <div className="tooltip">{text}</div>
            </div>
        );
    };

    const handleAddToFavourite = async (bidId) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit it!",
            cancelButtonText: "No, cancel",
        });
        if (result.isConfirmed) {
            dispatch(addBidToPendingList(bidId, token))
                .then((response) => {
                    if (response.statusCode === "00") {
                        dispatch(getBidList(token));
                        Swal.fire({
                            title: "Success!",
                            text: response.statusDesc,
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.error || "Failed to add bid to favourite",
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "Error!",
                        text: "There was an error adding the bid to favourite.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                });
        }

    };

    const columns = [
        {
            name: "SN",
            cell: (_, index) => index + 1,
            sortable: false,
            width: "80px",
            align: "center",
        },
        {
            name: "Bid Number",
            selector: (row) => row?.bidNumber || "-",
            sortable: true,
            align: "left",
        },
        {
            name: "Bid Title",
            selector: (row) => row?.bidTitle || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Category",
            selector: (row) => row?.categoryName || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Organization",
            selector: (row) => row?.organization || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Start Date",
            cell: (row) => {
                if (!row.startDate) return "-";

                const date = format(new Date(row.startDate), "dd-MM-yyyy");
                const time = format(new Date(row.startDate), "HH:mm a");

                return (
                    <div style={{ whiteSpace: "pre-line", textAlign: "center" }}>
                        {`${date}\n${time}`}
                    </div>
                );
            },
            sortable: true,
            align: "center",
        },
        {
            name: "End Date",
            cell: (row) => {
                if (!row.endDate) return "-";

                const date = format(new Date(row.endDate), "dd-MM-yyyy");
                const time = format(new Date(row.endDate), "HH:mm a");

                return (
                    <div style={{ whiteSpace: "pre-line", textAlign: "center" }}>
                        {`${date}\n${time}`}
                    </div>
                );
            },
            sortable: true,
            align: "center",
        },

        {
            name: "No of Quantities",
            selector: (row) => row?.totalQuantity ?? "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Action",
            selector: (row) => row,
            sortable: false,
            align: "center",
            cell: (row) => (
                row.isAdded === "N" && (
                    <Tooltip text="Add To Bid Data">
                        <button
                            type="button"
                            className="btn btn-success btn-sm"
                            onClick={() => handleAddToFavourite(row.id)}
                        >
                            <BsFillBookmarkStarFill size={12} />
                        </button>
                    </Tooltip>
                )
            ),

        },
    ];

    return (
        <div>
            <Navbar />

            <div className="main-content">
                <div className="container-fluid mt-4">
                    <div className="card3">
                        <div className="card-body">
                            <NewDataTable
                                columns={columns}
                                data={gembidlist || []}
                                tableName="GeM BIDS"
                                totalRecord={gembidlist?.length ?? 0}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

};

export default GemBid;
